import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  Store,
  FlaskConical,
  Mail,
  Activity,
  Crown,
  Settings,
  LogOut,
  Globe,
  CreditCard,
  HardDrive,
  Coins,
  Trash2,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/logo";

const links = [
  { to: "/", icon: LayoutDashboard, label: "Dashboard" },
  { to: "/users", icon: Users, label: "Kullanicilar" },
  { to: "/venues", icon: Store, label: "Isletmeler" },
  { to: "/ingredients", icon: FlaskConical, label: "Malzemeler" },
  { to: "/plans", icon: Crown, label: "Planlar" },
  { to: "/events", icon: Activity, label: "Olay Kayitlari" },
  { to: "/backgrounds", icon: LayoutDashboard, label: "Arkaplanlar" },
  { to: "/custom-domains", icon: Globe, label: "Custom Domains" },
  { to: "/payments", icon: CreditCard, label: "Odemeler" },
  { to: "/credit-packages", icon: Coins, label: "Kredi Paketleri" },
  { to: "/storage", icon: HardDrive, label: "Dosyalar" },
  { to: "/trash", icon: Trash2, label: "Geri Donusum" },
  { to: "/app-settings", icon: Settings, label: "AI Ayarlari" },
  { to: "/email-test", icon: Mail, label: "Email Test" },
  { to: "/email-templates", icon: Mail, label: "Email Sablonlari" },
];

export function Sidebar({ onLogout }: { onLogout: () => void }) {
  return (
    <aside className="flex h-screen w-64 flex-col border-r bg-card">
      <div className="flex h-16 items-center border-b px-5">
        {/* Sidebar header: full lockup + "Admin" suffix badge.
            size="md" fits the 64-unit-wide rail without truncating. */}
        <Logo size="md" variant="full" suffix="Admin" />
      </div>

      <nav className="flex-1 space-y-1 p-3">
        {links.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${
                isActive
                  ? "bg-primary/10 text-primary"
                  : "text-muted-foreground hover:bg-muted hover:text-foreground"
              }`
            }
          >
            <Icon className="size-5" />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="border-t p-3">
        <Button
          variant="ghost"
          className="w-full justify-start gap-3 text-muted-foreground"
          onClick={onLogout}
        >
          <LogOut className="size-5" />
          Cikis Yap
        </Button>
      </div>
    </aside>
  );
}
